
/* injects from baggage-loader */
require('./style.styl');

import SankeyChart from './SankeyChart'

export default SankeyChart



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/SankeyChart/index.js